import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { RenderDatePicker } from './Base';

import { RenderInput } from './Base';
import LoadingButton from '../../../widgets/LoadingButton';
import { Dialog, Button, MenuItem } from '@blueprintjs/core';
import { Select, ItemPredicate } from "@blueprintjs/select";

import { getYearsArray, filterRecipients } from '../../../../helpers/functions';
import { getData } from '../../../../helpers/request';
import url from '../../../../helpers/url';
import { loadDonorRecipientLinkProgresses } from '../../../../redux/actions/donorRecipient.actions';
import { sendDonorEmailUpdate } from '../../../../redux/actions/donorEmailUpdate.actions';
import { createParams } from '../../../../redux/reducers/base.reducers';


class SendDonorRecipientProgressEmailUpdateModal extends Component {
    constructor(props) {
        super(props);
        this.emptyForm = {
            recipient_progress_id: null,
        };
        this.state = {
            showModal: false,
            donorId: null,
            recipientId: null,
            donorRecipientLinkId: null,
            filterValue: '',
            donorRecipientProgressesById: {},
            donorRecipientProgressesOptions: null,
            form: this.emptyForm,
        };
    }
    componentDidMount() {
        window.addEventListener('open-send-donor-recipient-progress-update-modal', this.openModal);
    }
    componentWillUnmount() {
        window.removeEventListener('open-send-donor-recipient-progress-update-modal', this.openModal);
    }
    componentWillReceiveProps(nextProps) {
        const { donorRecipient: { saveSuccess }} = nextProps;
        if (saveSuccess) {
            this.closeModal();
        }
    }
    openModal = event => {
        const { detail } = event;

        this.setState({
            showModal: true,
            recipientId: detail.recipient_id,
            donorId: detail.donorId,
            donorRecipientLinkId: detail.donorRecipientLinkId,
            form: this.emptyForm,
        }, () => {this.loadDonorRecipientLinkProgresses();});
    }

    closeModal = () => {
        this.setState({ showModal: false });
    }

    updateFormHandler = ({ key, value }) => {
        console.log(key);
        console.log(value);
        const { form } = this.state;
        form[key] = value;
        console.log(form);
        this.setState({ form });
    }

    onKeyDown = event => {
        const evt = event || window.event;
        var key = evt.keyCode || evt.which;
        if (key === 13) {
            this.sendDonorEmailUpdate();
        }
    }

    loadDonorRecipientLinkProgresses = async () => {
        const { donorId, recipientId, donorRecipientLinkId, form } = this.state;
        const result = await getData({
            url: url.donorRecipientLinkProgresses.replace(':donorId', donorId).replace(':recipientId', recipientId).replace(':donorRecipientLinkId', donorRecipientLinkId),
        });
        const donorRecipientProgressInfo = createParams({ name: "donorRecipientProgresses", state: this.props.donorRecipient, data: result.data });

        console.log(donorRecipientProgressInfo.donorRecipientProgresses);
        console.log(donorRecipientProgressInfo.donorRecipientProgressesById);
        const donorRecipientProgressesOptions = []
        for (const progressInfo of donorRecipientProgressInfo.donorRecipientProgresses) {
            donorRecipientProgressesOptions.push(
                <option key={progressInfo.id} value={Number(progressInfo.id)}>{progressInfo.year_begin}</option>,
            )
        }

        if (donorRecipientProgressesOptions.length > 0) {
            this.updateFormHandler({ key: 'recipient_progress_id', value: Number(donorRecipientProgressesOptions[0].key)})
        }

        this.setState({
            donorRecipientProgressesById: donorRecipientProgressInfo.donorRecipientProgressesById,
            donorRecipientProgressesOptions: donorRecipientProgressesOptions,
        });
    }

    sendDonorEmailUpdate = () => {
        const { donorId, recipientId, donorRecipientLinkId, form } = this.state;

        this.props.sendDonorEmailUpdate({ donorId, recipientId, donorRecipientLinkId, form });
    }

    onRecipientProgressSelect = (item) => {
        this.updateFormHandler({key: "recipient_progress_id", value: parseInt(item.id, 10)});
    }

    handleFilterChange = (event) => {
        this.setState({ filterValue: event.target.value });
    }

    render() {
        const { showModal, form, donorRecipientProgressesOptions, donorRecipientProgressesById } = this.state;
        const { saveLoading: emailSending } = this.props.donorRecipient;
        const { recipientsById } = this.props.recipientState;

        const selectedRecipient = this.state.recipientId ? recipientsById[this.state.recipientId] : null;
        const selectedRecipientProgress = form.recipient_progress_id ? donorRecipientProgressesById[form.recipient_progress_id] : null;
        console.log(form);
        console.log(donorRecipientProgressesById);
        console.log(selectedRecipientProgress);
        console.log(donorRecipientProgressesOptions);
        return (
            <Dialog icon='envelope'
                style={{ width: '750px'}}
                isOpen={showModal}
                onClose={() => this.closeModal()}
                title="Send Progress Email Update">
                { showModal ?
                    <Fragment>
                        <div className="pt-dialog-body">
                            <div className="flex-row title-padding"><strong>Linked Recipient:</strong></div>
                            <div className="flex-row input-padding">
                                <Button
                                    text={
                                        `${selectedRecipient.first_name} ${selectedRecipient.middle_name} ${selectedRecipient.last_name} (${selectedRecipient.gender} | ${selectedRecipient.city_of_school} | ${selectedRecipient.country_of_school})`
                                    }
                                />
                            </div>
                            <div className="flex-row title-padding"><strong>Select a recipient progress year:</strong></div>
                            <div className="flex-row input-padding">

                                { donorRecipientProgressesOptions && donorRecipientProgressesOptions.length ? (
                                    <div className="pt-select">
                                        <select
                                            value={form.recipient_progress_id}
                                            onChange={event => this.updateFormHandler({ key: 'recipient_progress_id', value: Number(event.target.value) })}
                                            disabled={!donorRecipientProgressesOptions}
                                        >
                                            {donorRecipientProgressesOptions}
                                        </select>
                                    </div>
                                ) : (
                                    <div className="pt-label pt-icon-warning-sign pt-intent-danger pt-small">This recipient does not have any recipient progresses. Unable to send an email update without a progress.</div>
                                )}
                            </div>
                        </div>
                        <div className="pt-dialog-footer">
                            <div className="pt-dialog-footer-actions">
                                <LoadingButton
                                    className="pt-button pt-fill pt-intent-primary pt-large"
                                    text="Send Email Update"
                                    onClick={this.sendDonorEmailUpdate}
                                    isLoading={emailSending}
                                    disabled={!selectedRecipientProgress}
                                />
                            </div>
                        </div>
                    </Fragment> : null
                }
            </Dialog>
        );
    }
}

export default connect(
    (state) => ({
        recipientState: state.recipient,
        donorRecipient: state.donorRecipient,
    }),
    { loadDonorRecipientLinkProgresses, sendDonorEmailUpdate }
)(SendDonorRecipientProgressEmailUpdateModal);



// WEBPACK FOOTER //
// ./src/components/main/dashboard/modals/DonorEmailUpdate.jsx